// Action links removed — mobile uses MaterialBottomNav, desktop uses left nav sidebar.
export const featurePageMapping: { [key: string]: PageMapping } = {
	"/material": {
		actions: [],
		buttons: [],
		icon: "inventory_2",
		label: "Material",
		labelKey: "nav.material.module.label",
		nav: false,
		title: ""
	},
	"/material/count": {
		actions: [],
		buttons: [],
		icon: "inventory_2",
		label: "Count",
		labelKey: "nav.material.count.label",
		nav: true,
		title: "Count Material",
		titleKey: "nav.material.count.title"
	},
	"/material/move": {
		actions: [],
		buttons: [],
		icon: "move_down",
		label: "Move",
		labelKey: "nav.material.move.label",
		nav: true,
		title: "Move Material",
		titleKey: "nav.material.move.title"
	},
	"/material/receive": {
		actions: [],
		buttons: [],
		icon: "local_shipping",
		label: "Receive",
		labelKey: "nav.material.receive.label",
		nav: true,
		title: "Receive Purchase Order",
		titleKey: "nav.material.receive.title"
	},
	"/material/count-assigned": {
		actions: [],
		buttons: [],
		icon: "fact_check",
		label: "Assigned",
		labelKey: "nav.material.countAssigned.label",
		nav: true,
		title: "My Counts Today",
		titleKey: "nav.material.countAssigned.title"
	},
	"/material/history": {
		actions: [],
		buttons: [],
		icon: "history",
		label: "History",
		labelKey: "nav.material.history.label",
		nav: true,
		title: "Transaction History",
		titleKey: "nav.material.history.title"
	},
	"/material/receive-transfer": {
		actions: [],
		buttons: [],
		icon: "swap_horiz",
		label: "Receive Transfer",
		labelKey: "nav.material.receiveTransfer.label",
		nav: false,
		title: "Receive Transfer Order",
		titleKey: "nav.material.receiveTransfer.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};
